//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import Heading from '@/mixins/heading';

export default {
  name: 'BaseSectionHeading',

  mixins: [Heading],

  props: {
    align: {
      type: String,
      default: 'center',
    },
    color: {
      type: String,
      default: 'primary',
    },
    icon: { type: [String, Object], default: null },
    outlined: Boolean,
    space: {
      type: [Number, String],
      default: 12,
    },
    subtitle: { type: String, default: null },
    text: { type: String, default: null },
    title: { type: String, default: null },
  },

  computed: {
    classes() {
      return [`text-${this.align}`, `mb-${this.space}`];
    },
  },
};
